import { Component } from '@angular/core';
import { ROUTES } from './side-nav-routes.config';
import { ThemeConstantService } from '../../services/theme-constant.service';
import { NgxPermissionsService } from 'ngx-permissions';
import { AuthenticationService } from '../../services/authentication.service';
import { NgxPermission } from 'ngx-permissions/lib/model/permission.model';

@Component({
  selector: 'app-sidenav',
  templateUrl: './side-nav.component.html',
})
export class SideNavComponent {
  public menuItems: any[];
  isFolded: boolean;
  isSideNavDark: boolean;
  isExpand: boolean;

  constructor(
    private themeService: ThemeConstantService,
    private auth: AuthenticationService,
    private permissionService: NgxPermissionsService
  ) {}

  ngOnInit(): void {
    this.menuItems = ROUTES.filter((menuItem) => menuItem);
    this.themeService.isMenuFoldedChanges.subscribe(
      (isFolded) => (this.isFolded = isFolded)
    );
    this.themeService.isExpandChanges.subscribe(
      (isExpand) => (this.isExpand = isExpand)
    );
    this.themeService.isSideNavDarkChanges.subscribe(
      (isDark) => (this.isSideNavDark = isDark)
    );

    const permissions = [
      'listMeeting',
      'seeMeeting',
      'editMeeting',
      'deleteMeeting',
    ];

    // this.permissionService.loadPermissions(
    //   JSON.parse(
    //     atob(this.auth.currentUserValue.user.role.permission.split('@')[0])
    //   ).filter((perm: any) => perm != '')
    // );

    // this.permissionService.loadPermissions(
    //   JSON.parse(
    //     atob(this.auth.currentUserValue.user.role.permission.split('@')[0])
    //   ),
    //   (permissionName, permissionStore) => {
    //     return !!permissionStore[permissionName];
    //   }
    // );

    console.log(
      'Permissions du user : ',
      JSON.parse(
        atob(this.auth.currentUserValue.user.role.permission.split('@')[0])
      ).filter((perm) => perm != ''),
      this.permissionService
        .hasPermission('xxx')
        .then((result) => console.log('Valeur : ', result))
    );
  }

  hasPermission(permissions: string[]): Promise<boolean> {
    console.log(
      'Autorisé ? => ',
      this.permissionService.hasPermission(permissions)
    );
    return this.permissionService.hasPermission(permissions);
  }

  ngAfterViewInit(): void {
    /* Collapsed Menu dropdown */
    let submenus = document.querySelectorAll('.ant-menu li.ant-menu-submenu');
    let direction = document.querySelector('html').getAttribute('dir');
    submenus.forEach((item) => {
      item.addEventListener('mouseover', function () {
        let menuItem = this;
        let menuItemRect = menuItem.getBoundingClientRect();
        let submenuWrapper = menuItem.querySelector('ul.ant-menu-sub');
        submenuWrapper.style.top = `${menuItemRect.top}px`;
        if (direction === 'ltr') {
          submenuWrapper.style.left = `${
            menuItemRect.left + Math.round(menuItem.offsetWidth * 0.75) + 10
          }px`;
        } else if (direction === 'rtl') {
          submenuWrapper.style.right = `${
            Math.round(menuItem.offsetWidth * 0.75) + 10
          }px`;
        }
      });
    });
  }

  closeMobileMenu(): void {
    if (window.innerWidth < 992) {
      this.isFolded = false;
      this.isExpand = !this.isExpand;
      this.themeService.toggleExpand(this.isExpand);
      this.themeService.toggleFold(this.isFolded);
    }
  }
}
